import type { AttachmentTypeName } from 'src/constants/attachmentTypes';
import type { IJobApplication } from 'src/stores/JobApplicationStore/JobApplication';

import { PER_PAGE } from '../../constants/numPerPage';

const convertBooleanAttribute = (booleanValue: boolean) =>
  booleanValue ? 1 : 0;

const getCandidateEventAttributes = (
  jobApplication: IJobApplication,
  isMobile = false,
) => {
  const {
    candidateId,
    positionInList,
    attachments,
    certifiedRoleRequirements,
    matchRoleRequirements,
    notCustomRoleRequirements,
    id,
  } = jobApplication;

  const documentTypes: AttachmentTypeName[] = attachments
    .map((attachment) => attachment.typeName)
    .filter((x): x is AttachmentTypeName => Boolean(x));

  const hasDocument = documentTypes.length > 0;

  const attachmentPreviewed =
    !isMobile && hasDocument ? documentTypes[0] : undefined;

  return {
    documentTypes,
    attachmentPreviewed,
    candidateId: parseInt(candidateId, 10),
    prospectId: parseInt(id, 10),
    position: positionInList,
    isDefault: convertBooleanAttribute(false),
    isCertsyVerified: convertBooleanAttribute(
      certifiedRoleRequirements.length > 0,
    ),
    roleReqAnswerPreferredCount: matchRoleRequirements.length,
    roleReqQuestionCount: notCustomRoleRequirements.length,
    pageNumber: Math.ceil(positionInList / PER_PAGE),
  };
};

export default getCandidateEventAttributes;
